import { LinkRenderer } from '@/components/elements/Link';
import { IComponentSharedPartnerLink } from '@/graphql/__generated__/global/types';
import Image from 'next/image';

export type PartnerLinkProps = {
    partnerLink: IComponentSharedPartnerLink;
};

export const PartnerLink = ({ partnerLink }: PartnerLinkProps) => {
    const { image, openInNew, title, url } = partnerLink;
    const { alternativeText, height, name = '', url: imgSrc, width } = image?.data?.attributes || {};
    const logo = imgSrc ? <Image alt={alternativeText || title || name} className={'max-h-[100px] max-w-[100px]'} height={height} src={imgSrc} width={width} /> : title;

    if (url) {
        return (
            <LinkRenderer forceTarget={openInNew ? '_blank' : undefined} linkToExternalPage={url}>
                {logo || url}
            </LinkRenderer>
        );
    }

    return logo;
};
